import React from 'react';
import { Spinner } from 'reactstrap';

function LoadingComponent() {
  return (
    <div
      className="w-100 d-flex justify-content-center align-items-center"
      style={{ height: 100 }}
    >
      <Spinner color="secondary" />
    </div>
  );
}

export default LoadingComponent;